import moment from 'moment-timezone'

const formatTimeAndDate = (patientCallData) => {
  const formattedData = patientCallData.slice(0)
  formattedData.forEach((formattedDataObj) => {
    formattedDataObj.formattedTime = moment(formattedDataObj.ring_start).format('h:mm a')
    formattedDataObj.formattedDate = moment(formattedDataObj.ring_start).format('MMM DD, YYYY')
  })
  return formattedData
}

export default formatTimeAndDate



// WEBPACK FOOTER //
// ./src/services/call-log-helpers.js